import * as React from 'react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../card';
import { Button } from '../button';
import { Input } from '../input';
import { Label } from '../label';

export type TransferOutAmountCardLabels = {
  amountTitle: string;
  amountSubtitle: string;
  amountLabel: string;
  amountPlaceholder: string;
  max: string;
  pct25: string;
  pct50: string;
  pct75: string;
};

export type TransferOutAmountCardProps = {
  balance: number;
  transferAmount: string;
  onTransferAmountChange: (value: string) => void;
  labels: TransferOutAmountCardLabels;
  amountInputId?: string;
};

export function TransferOutAmountCard({
  balance,
  transferAmount,
  onTransferAmountChange,
  labels,
  amountInputId = 'transfer-out-amount',
}: TransferOutAmountCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{labels.amountTitle}</CardTitle>
        <CardDescription>{labels.amountSubtitle}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label htmlFor={amountInputId}>{labels.amountLabel}</Label>
          <Input
            id={amountInputId}
            type="number"
            step="0.01"
            min="0"
            max={balance}
            value={transferAmount}
            onChange={(e) => onTransferAmountChange(e.target.value)}
            placeholder={labels.amountPlaceholder}
            className="text-lg"
          />
        </div>

        <div className="flex justify-between gap-1 flex-wrap text-sm">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => onTransferAmountChange((balance * 0.25).toFixed(2))}
          >
            {labels.pct25}
          </Button>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => onTransferAmountChange((balance * 0.5).toFixed(2))}
          >
            {labels.pct50}
          </Button>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => onTransferAmountChange((balance * 0.75).toFixed(2))}
          >
            {labels.pct75}
          </Button>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => onTransferAmountChange(balance.toFixed(2))}
          >
            {labels.max}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
